import { BaseDataType, ValidBusinessObject } from '@iotv/iotv-v3-types'
import { randomUUID } from 'crypto'

let getRuleJson = () => {
  let ruleJson = constructRuleset({
    name: 'EFFUnexpectedStationary',
    type: 'EffluentTracker',
    keyAttribute: 'unexpectedStationary',
    value: 1,
    count: 1,
  })

  return ruleJson
}

const constructRuleset = (parameters: { name: string; type: string; keyAttribute: string; value: number; count: number }) => {
  let { name, type, keyAttribute, value, count } = parameters
  let RuleId = randomUUID()
  let MetricId = randomUUID()

  let ruleJson: ValidBusinessObject = {
    pk: `Ruleset:${RuleId}`,
    sk: `Ruleset:${RuleId}`,
    appliesToType: `${type}`,
    definition: {
      GeofenceRule: [],
      MetricRule: [
        {
          pk: `MetricRule:${MetricId}`,
          sk: `MetricRule:${MetricId}`,
          enabled: true,
          failMessage: ['failed message'],
          id: '0',
          max: {
            datapoints: count,
            value: value,
          },
          min: {
            datapoints: 0,
            value: 0,
          },
          name: 'new Metric Rule',
          stdDev: {
            datapoints: 0,
            value: 0,
          },
          type: 'MetricRule',
          _key: `${keyAttribute}`,
        },
      ],
    },
    globallyApplyToObjectTypeId: true,
    id: `${RuleId}`,
    name: `${name}`,
    possibleAppliesToTypes: [`${type}`],
    rulesetContent: 'METRIC',
    type: 'Ruleset',
  }

  return ruleJson
}

export const rules: BaseDataType = {
  Ruleset: {
    names: [],
    itemProducers: [async () => [getRuleJson()]],
  },
}
